export const adminMenu = [
    {
        "id": 1,
        "icon": "dashboard",
        "label": "Menu_Dashboard", 
        "to": "/dashboard"
    },
    {
        "id": 2,
        "icon": "black-tie",
        "label": "Menu_Teachers", 
        "to": "/teachers"
    },
    {
        "id": 4,
        "icon": "users",
        "label": "Menu_Students", 
        "to": "/students"
    },
    {
        "id": 6,
        "icon": "graduation-cap",
        "label": "Menu_Courses", 
        "to": "/courses-mgr"
    },
    {
        "id": 7,
        "icon": "gears",
        "label": "Menu_Programs", 
        "to": "/programs"
    },
]

export const universityMenu = [
    {
        "id": 1,
        "icon": "dashboard",
        "label": "Menu_Dashboard", 
        "to": "/"
    },
    {
        "id": 6,
        "icon": "graduation-cap",
        "label": "Menu_Courses", 
        "to": "/courses"
    },
];